module.exports = __webpack_public_path__ + "static/media/susbg.a6e309f8.jpg";